import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import CustomerInvoiceCollectionPageUI from './CustomerInvoiceCollectionPageUI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'

class CustomerInvoiceCollectionPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      invoiceList: null,
      createMode: false,
      customerList: null,
      utilizeMode: false,
      showInvoices: false
    }
  }

  render() {
    return (
      <CustomerInvoiceCollectionPageUI
        context={this.props.context}
        account={this.state.account}
        invoiceList={this.state.invoiceList}
        customerList={this.state.customerList}
        onRefreshClick={this.onRefreshClick}
        //
        createMode={this.state.createMode}
        onCreateClick={() => { this.setState({ createMode: true }) }}
        onCancelCreateInvoice={() => { this.setState({ createMode: false }) }}
        //
        utilizeMode={this.state.utilizeMode}
        selectedCustomerId={this.state.selectedCustomerId}
        customerInvoiceList={this.state.customerInvoiceList}
        onUtilizeClick={this.onUtilizeClick}
        onUtilizeClickCancel={() => { this.setState({ utilizeMode: false }) }}
        //
        onShowInvoicesClick={this.onShowInvoicesClick}
        showInvoices={this.state.showInvoices}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getCustomers(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Account(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getCustomers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/customers`,
      cacheKey: CacheKeys.Customers(this.props.match.params.accountId),
      callback: this.getCustomersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getCustomersCallback = (response) => {
    this.setState({
      customerList: response.customerList
    })
  }

  onShowInvoicesClick = (event) => {
    let customerId = event.currentTarget.getAttribute('data-row-id')
    this.setState({ showInvoices: true, selectedCustomerId: customerId })
    this.getInvoices(this.props.context, customerId)
  }

  getInvoices(context, customerId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/customers/${customerId}/funds/unutilized/utilize/customerInvoices/statuses/disbursed,paid`,
      cacheKey: CacheKeys.CustomerInvoices(customerId),
      callback: this.getInvoicesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }
  getInvoicesCallback = (response) => {
    let customerInvoiceList = response.invoiceList.map((invoice) => {
      return { key: invoice.customerInvoiceId, value: invoice.invoiceName + ' - ' + invoice.invoiceAmountF2 }
    })
    this.setState({ invoiceList: response.invoiceList, showInvoices: false, customerInvoiceList: customerInvoiceList })
  }

  onUtilizeClick = (event) => {
    let customerId = event.currentTarget.getAttribute('data-row-id')
    this.setState({ utilizeMode: true, selectedCustomerId: customerId })
    this.getInvoices(this.props.context, customerId)
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Account(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.Customers(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.CustomerInvoices(this.state.selectedCustomerId))
    this.setState({ customerList: null },
      () => {
        this.getAccounts(context)
        this.getCustomers(context)
        this.getInvoices(context, this.state.selectedCustomerId)
      }
    )
  }
}

export default withRouter(CustomerInvoiceCollectionPageSF)
